import AnimatedInput from './AnimatedInput';

export default AnimatedInput;
